export default function Footer() {
  return (
    <footer className="bg-gray-950 text-gray-500 py-8 text-center text-sm">
      <p>&copy; {new Date().getFullYear()} Mitch Brey. All rights reserved.</p>
      <p className="mt-2">Built with React & Tailwind CSS.</p>
    </footer>
  );
}
